import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { disableBrowserScrollRestoration, resetWindowScroll } from '../helpers/scroll'

export function useScrollToTop() {
  const { pathname, hash } = useLocation()

  useLayoutEffect(() => {
    disableBrowserScrollRestoration()
  }, [])

  useLayoutEffect(() => {
    if (hash) return
    resetWindowScroll()
    const frame = window.requestAnimationFrame(() => {
      resetWindowScroll()
    })
    return () => window.cancelAnimationFrame(frame)
  }, [pathname, hash])
}
